import {
  EVENT_NAME,
  EventProps,
  trackAnalyticsEvent,
} from '@leagueplatform/analytics';
import {
  GDSStyleObject,
  Icon,
  queryHelpers,
  TextAction,
  useMediaQuery,
} from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { useNavigate } from 'react-router-dom';

export const BackButtonArrow = ({
  css,
  analyticsEventProps,
}: {
  css?: GDSStyleObject;
  analyticsEventProps?: EventProps;
}) => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery(queryHelpers.down('laptop'));
  const { formatMessage } = useIntl();

  const handleClick = () => {
    trackAnalyticsEvent(EVENT_NAME.BUTTON_CLICKED, {
      detail: 'back arrow button',
      ...analyticsEventProps,
    });
    navigate(-1);
  };

  return (
    <TextAction
      onClick={handleClick}
      as="button"
      css={{
        color: '$onSurfaceIconPrimary',
        ...css,
      }}
    >
      <Icon
        icon={isMobile ? 'interfaceChevronLeft' : 'interfaceArrowLeft'}
        label={formatMessage({ id: 'GO_BACK' })}
      />
    </TextAction>
  );
};
